import React, { useState, useMemo } from "react";
import { Search } from "lucide-react";
import debounce from "lodash.debounce";
import "../styles/components/SearchBar.css";

const SearchBar = ({ onSearch, containerStyles = {} }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const debouncedSearch = useMemo(
    () => debounce((value) => {
      if (onSearch) {
        onSearch(value);
      }
    }, 500),
    [onSearch]
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  return (
    <div style={containerStyles}>
      <button className="search-button centre gap-10">
        <input
          type="text"
          className="searchBar-input"
          placeholder={`Search value`}
          value={searchTerm}
          onChange={handleSearch}
        />
        <Search size={23} color="#c5c5c5" className="search-icon" />
      </button>
    </div>
  );
};

export default SearchBar;
